import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import ReviewerWaitForWithdrawTableWidget from '../../widgets/admin/ReviewerWaitForWithdrawTableWidget'
import WithdrawalByReviewerPanel from '../../widgets/admin/WithdrawalByReviewerPanel'
import { getReviewerPaymentDetailByReviewer } from '../../redux/actions/withdrawReviewPayment'

export default function SendWithdrawReviewByReviewer() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [reviewerData, setReviewerData] = useState()
  const [showTableDetail, setShowTableDetail] = useState(true)
  const [status, setStatus] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = {
        projectReviewerPaymentId: null,
        masterReviewerId: null,
        status: 0,
      }
      const response = await getReviewerPaymentDetailByReviewer(request)
      setSchema(response.model)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errorMessage,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSelectedRowData = async (rowData, status) => {
    setIsLoading(true)
    startLoading()
    setReviewerData()
    try {
      console.log(rowData)
      let request = {
        // personId : rowData.personId,
        budgetYear: rowData.budgetYear,
        // isReviewOnline : rowData.isReviewOnline,
        projectReviewerPaymentId: rowData.id,
        masterReviewerId: rowData.personId,
        status: status || 1,
      }
      //get project by reviewer id
      const response = await getReviewerPaymentDetailByReviewer(request)

      //response.model.forms.projectBudgetPlan.masterBudgetPlan.label = 'แผนงบประมาณ'

      setShowTableDetail(false)
      setReviewerData(rowData)
      setStatus(status)
      setSchema(response.model)
      //setSchema(mockSchemaProjectList.model)
    } catch (e) {
      //setError({})
      setShowTableDetail(false)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnCancelShowTable = () => {
    setShowTableDetail(true)
    setReviewerData()
  }

  const handleOnSuccess = async (status, projectReviewerPaymentId) => {
    setStatus(status)
    const rowData = {
      ...reviewerData,
      id: projectReviewerPaymentId,
    }
    handleOnSelectedRowData(rowData, status)
  }

  if (error) {
    return (
      <SidebarProposal isReviewPayment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
      // <div className="custom-dashboard">
      //   <TopLevelNav />
      //   <PageToolbar />
      //   <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      // </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReviewPayment>
        <PanalLoadingTemplate />
      </SidebarProposal>

      // <div className="custom-dashboard">
      //   <TopLevelNav />
      //   <PageToolbar />
      //   <PanalLoadingTemplate />
      // </div>
    )
  }

  return (
    <SidebarProposal isReviewPayment>
      {/* <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar /> */}

      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <Panel header={schema.header} shaded collapsible bordered defaultExpanded>
        <ReviewerWaitForWithdrawTableWidget
          onSelectedRowData={handleOnSelectedRowData}
          onShow={showTableDetail}
          onChangeShow={() => setShowTableDetail(!showTableDetail)}
          statusOptions={schema?.forms?.statusOptions || []}
          statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
        />
        <br />
        {schema.forms && reviewerData && (
          <WithdrawalByReviewerPanel
            schema={schema.forms}
            reviewerData={reviewerData}
            status={status}
            onSuccess={handleOnSuccess}
            onCancelShowTable={handleOnCancelShowTable}
            statusOptions={schema?.forms?.statusOptions || []}
            statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
            onButtonSuccess={() => handleOnSelectedRowData(reviewerData, status)}
          />
        )}
        <br />
      </Panel>
      {/* </div> */}
    </SidebarProposal>
  )
}
